$(document).ready(function () {
  $(".product-info__block-item").addClass("Add-to-Cart-sticky");
  $("body").on("change", ".cstm_select_coll", function (e) {
    var i = $(this).find("option").attr("pro_handle");
    var vimg = $(this).find("option:selected").attr("vimg");
    var vid = $(this).val();
    var newVariantId = parseInt(vid);
    $(this)
      .parents("product-card")
      .find(".product-card__media img")
      .attr("src", vimg);
    $(this)
      .parents("product-card")
      .find(".product-card__media img")
      .attr("srcset", vimg);
    $(this).parents("product-card").find("[name=id]").val(vid);

    // Update data-variant-id on the collection_atc wrapper
    var collectionAtc = $(this).parents("product-card").find(".collection_atc")[0];
    if (collectionAtc) {
      collectionAtc.setAttribute("data-variant-id", newVariantId);
      // Also update the variants_ class so the JS lookup still works
      collectionAtc.className = collectionAtc.className.replace(/variants_\d+/, 'variants_' + newVariantId);
      // Fetch cart and update items_cart for the newly selected variant
      fetch("/cart.js").then(function(r){ return r.json(); }).then(function(cart) {
        var qty = 0;
        for (var ci = 0; ci < cart.items.length; ci++) {
          if (cart.items[ci].variant_id === newVariantId) {
            qty = cart.items[ci].quantity;
            break;
          }
        }
        collectionAtc.setAttribute("items_cart", qty);
      });
    }

    var __this = $(this);
    // variant wise price
    fetch("/products/" + i + "?variant=" + vid + "&view=collection-price", {
      credentials: "same-origin",
      method: "GET",
    }).then(function (content) {
      content.text().then(function (html) {
        __this
          .parents("product-card")
          .find(".list__collection_price")
          .html(html);
      });
    });
    // End variant wise price
    // variant available
    fetch(
      "/products/" +
        i +
        "?variant=" +
        vid +
        "&view=collection-grid-variant-available",
      {
        credentials: "same-origin",
        method: "GET",
      }
    ).then(function (content) {
      content.text().then(function (avb) {
        let avb1 = avb.trim();
        if (avb1 == "true") {
          __this
            .parents("product-card")
            .find(".buy-buttons button")
            .html(
              '<span class="atc-text">Add to cart</span><span class="atc-loader" style="display:none;color:#ffffff;">Adding..</span>'
            );
          __this
            .parents("product-card")
            .find(".buy-buttons button")
            .removeAttr("disabled");
        } else {
          __this
            .parents("product-card")
            .find(".buy-buttons button")
            .html("Sold Out");
          __this
            .parents("product-card")
            .find(".buy-buttons button")
            .attr("disabled", "disabled");
        }
      });
    });
    // End variant available
    e.preventDefault();
  });

  $("body").on("change", ".cstm_select_coll1", function () {
    var selectedOption = $(this).find(":selected");
    var Prdid = selectedOption.attr("vid");
    var Prdimg = selectedOption.attr("vimg");
    var PrdPrice = selectedOption.attr("data-price");
    var PrdPrice1 = PrdPrice / 100;
    var Prd_CmPrice = selectedOption.attr("data-compare");
    var Prd_CmPrice1 = Prd_CmPrice / 100;
    var Prd_discount = selectedOption.attr("discount");
    var Save_val = selectedOption.attr("saveprice");
    var PrdTitle = selectedOption.attr("proTitle");
    var available = selectedOption.attr("data-available");
    var product_url = selectedOption.attr("product_url")
    $(this)
      .parents(".product-card__info")
      .find(".product-title")
      .text(PrdTitle);
    $(this)
      .parents(".product-card__info")
      .find(".clubed_price2")
      .text("₹" + PrdPrice1);
    if (available === "true") {
      $(this)
        .parents(".product-card__info")
        .find(".button.w-full")
        .text("Add to cart")
        .css("pointer-events", "auto");
    } else {
      $(this)
        .parents(".product-card__info")
        .find(".button.w-full")
        .text("Sold out")
        .css("pointer-events", "none");
    }
    if (Prd_CmPrice1) {
      $(this)
        .parents(".product-card__info")
        .find("compare-at-price")
        .removeAttr("hidden");
      $(this)
        .parents(".product-card__info")
        .find(".com_clubed_price2")
        .text("₹" + Prd_CmPrice1);
      $(this)
        .parents(".product-card__info")
        .find(".list__collection_price .cstm_off_dis_cstm")
        .show()
        .text(Prd_discount);
      $(this)
        .parents(".product-card__info")
        .find(".list__collection_price .cstm_discount_1")
        .hide();
      $(this)
        .parents(".product-card")
        .find(".badge--on-sale")
        .show()
        .text("Save ₹" + Save_val);
    } else {
      $(this)
        .parents(".product-card__info")
        .find("compare-at-price")
        .attr("hidden", "");
      $(this)
        .parents(".product-card__info")
        .find(".list__collection_price .cstm_off_dis_cstm")
        .hide();
      $(this)
        .parents(".product-card__info")
        .find(".list__collection_price .cstm_discount_1")
        .hide();
      $(this).parents(".product-card").find(".badge--on-sale").hide();
    }
    $(this)
      .parents(".product-card__info")
      .find(".cstn_atcc .Cstm_var_id")
      .attr("value", Prdid);
    $(this)
      .parents(".product-card")
      .find(".product-card__figure .product-card__media img")
      .attr("src", Prdimg);
    $(this)
      .parents(".product-card")
      .find(".product-card__figure .product-card__media img")
      .attr("srcset", Prdimg);
  });
});

// pdp tab section
$(".cstm_description").css("display", "none");
$("cstm_highlights").css("display", "block");
$(document).ready(function () {
  $(".tab_name").click(function () {
    var attr = $(this).attr("data-attr");
    $(this)
      .parents(".top_outer_section ")
      .find(".cstm_" + attr)
      .show()
      .siblings()
      .hide();
    $(this).addClass("active").siblings().removeClass("active");
  });
});
// end here

$(document).ready(function () {
  $("body").on("click", ".closeSearchBar", function () {
    $(".predictive-search__content").html("");
    $("input.header-search__input").val("");
  });
});

/*-------cart all price show/hide code starts------*/
$(document).ready(function () {
  $(".cstm_cart_drawer div.hide_details_div").hide();
  $("body").on("click", ".cstm_total_cart_view", function () {
    $(
      ".cstm_cart_drawer .all_price_details_div div.hide_details_div"
    ).slideDown();
    $(".cstm_cart_drawer .all_price_details_div").addClass(
      "active_all_price_details"
    );
  });
  $("body").on("click", ".hide_details", function () {
    $(this).parent("div.hide_details_div").slideUp();
    $(".cstm_cart_drawer .all_price_details_div").removeClass(
      "active_all_price_details"
    );
  });
});
/*-------cart all price show/hide code ends------*/

/******************** For Manually Reviews Design********************/

$("#section-review").slick({
  dots: true,
  infinite: false,
  speed: 300,
  arrows: false,
  slidesToShow: 2,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 699,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});
/******************** End For Manually Reviews Design********************/

//*********** Product page variant discount show code starts*************//
$(document).ready(function () {
  var clickedPrice = parseInt($(".block-swatch").attr("price_com"));
  $(".block-swatch").each(function () {
    var currentPrice = parseInt($(this).attr("price_com"));
    if (clickedPrice < currentPrice) {
      $(this).addClass("show_discount");
    } else {
      $(this).removeClass("show_discount");
    }
  });

  $(".block-swatch").click(function () {
    var clickedPrice = parseInt($(this).attr("price_com"));
    $(".block-swatch").each(function () {
      var currentPrice = parseInt($(this).attr("price_com"));
      if (clickedPrice < currentPrice) {
        $(this).addClass("show_discount");
      } else {
        $(this).removeClass("show_discount");
      }
    });
  });
});
//*********** Product page variant discount show code starts*************//

//---------testimonial page review popup code starts-----------------//
$("body").on("click", ".review_popup__form", function (e) {
  var i = $(this).attr("pro_handle");
  fetch("/products/" + i + "?view=reviews", {
    credentials: "same-origin",
    method: "GET",
  }).then(function (content) {
    content.text().then(function (html) {
      $(".review__testmonials__form").html(html);

      var container = document.createElement("div");
      container.innerHTML = html;
      $(".modal-review-poup").show();
    });
  });
  e.preventDefault();
});

$(".choose_review_product").change(function () {
  var i = $(this).val();
  fetch("/products/" + i + "?view=reviews", {
    credentials: "same-origin",
    method: "GET",
  }).then(function (content) {
    content.text().then(function (html) {
      $(".review__testmonials__form").html(html);
      var container = document.createElement("div");
      container.innerHTML = html;
    });
  });
  e.preventDefault();
});
$("body").on("click", ".close-review-popup", function (e) {
  $(".modal-review-poup").hide();
});
//---------testimonial page review popup code ends-----------------//
// --------start footer accordan ----------------//
  function handleAccordionClick() {
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    if (viewportWidth < 699) {
      var accordionHeadings = document.querySelectorAll('.footer-acc-heading');
      accordionHeadings.forEach(function (heading) {
        heading.addEventListener('click', function () {
          var currentHeading = this;
          var currentContent = this.nextElementSibling;
          if (currentContent.classList.contains('activeClass')) {
            currentHeading.classList.remove('headingClass');
            currentContent.classList.remove('activeClass');
          } else {
            accordionHeadings.forEach(function (otherHeading) {
              otherHeading.classList.remove('headingClass');
            });
            var accordionContents = document.querySelectorAll('.footer-acc-content');
            accordionContents.forEach(function (content) {
              content.classList.remove('activeClass');
            });
            currentHeading.classList.add('headingClass');
            currentContent.classList.add('activeClass');
          }
        });
      });
    }
  }
  handleAccordionClick();
//-----------------------end--------------------
$(document).ready(function() { 
$("body").on('click','.AdobeAtc',function() {
    gtag('event', 'Add to Cart', {
    'send_to': 'AW-10869353894/yhqZCL-ntNEDEKbb9L4o',
      
    });
  });
});

document.addEventListener("DOMContentLoaded", function() {
  const urlString = window.location.href;
  const queryString = urlString.split("?")[1];
if(queryString){
  const hairQuiz = document.querySelector('.hairquiz'); 
  const nextlink = hairQuiz.getAttribute('href'); 
  const finalValue = `${nextlink}?${queryString}`;
  hairQuiz.setAttribute('href', finalValue); 
}
});


var passwordField = document.querySelector('.user_password');
var user_first_name = document.querySelector('.user_first_name');
var user_last_name = document.querySelector('.user_last_name');
var user_email = document.querySelector('.user_email');
var newElement = document.createElement('span');
var buttonFiled = document.querySelector('#create_customer .button');
var checkBox = document.getElementById("recieveUserAge");
newElement.classList.add("errorPass");
var afterElement = passwordField?.nextElementSibling.after(newElement);
function updateSubmitButton() {
  var buttonFiled = document.querySelector('#create_customer .button');
  var newElement = document.createElement('span');
  var tgtfirst = user_first_name.value.trim();
  var tgtlast = user_last_name.value.trim();
  var userEmail = user_email.value.trim();
  var passwordValue = passwordField.value.trim();
  var afterElement = document.querySelector('.errormsg');
 // passwordField?.nextElementSibling.after('')
  if (tgtfirst && tgtlast && userEmail && passwordValue && checkBox.checked === true) {
     // let passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@.#$!%*?&])[A-Za-z\d@.#$!%*?&]{8,15}$/;
     let passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%&])[A-Za-z\d@#$%&]{8,15}$/;
     // let passwordRegex = /^[a-zA-Z0-9@#$%&*]{8,15}$/;

    if (passwordRegex.test(passwordValue)) {
      afterElement.textContent = 'Valid password';
      afterElement.style.display = 'block';
      afterElement.style.color = 'green';
      buttonFiled.setAttribute('type', 'submit');
    } else {
      afterElement.textContent = 'Enter a valid password: minimum 8 characters, 1 uppercase, 1 lowercase, 1 number, 1 special character [ @ # $ % & * ].';
      afterElement.style.display = 'block';
      afterElement.style.color = 'red';
      buttonFiled.setAttribute('type', 'button');
    }
  } else {
    console.log("buttonFiled>>",buttonFiled)
    afterElement.textContent = 'Please fill in all fields.';
    afterElement.style.display = 'block';
    afterElement.style.color = 'red';
    buttonFiled.setAttribute('type', 'button');
  }

 // passwordField?.nextElementSibling.after(newElement);
}

if (checkBox) {
  checkBox.addEventListener('input', updateSubmitButton);
}

user_first_name?.addEventListener('input', updateSubmitButton);
user_last_name?.addEventListener('input', updateSubmitButton);
user_email?.addEventListener('input', updateSubmitButton);
passwordField?.addEventListener('input', updateSubmitButton);
buttonFiled?.addEventListener('click', function () {
  updateSubmitButton();
});

// Add event listener to the "add_value" button
var addButton = document.getElementById('add_value');
if (addButton) {
  addButton.addEventListener('click', validateFields);
}

function validateFields() {
  var tgtfirst = user_first_name.value.trim();
  var tgtlast = user_last_name.value.trim();
  var userEmail = user_email.value.trim();
  var passwordValue = passwordField.value.trim();

  // Check each input field and display an error message if needed
  if (!tgtfirst) {
    displayError(user_first_name, 'First name is required.');
  } else {
    clearError(user_first_name);
  }

  if (!tgtlast) {
    displayError(user_last_name, 'Last name is required.');
  } else {
    clearError(user_last_name);
  }

  if (!userEmail) {
    displayError(user_email, 'Email is required.');
  } else {
    clearError(user_email);
  }

  if (!passwordValue) {
    displayError(passwordField, 'Password is required.');
  } else {
    clearError(passwordField);
  }

  // Check the checkbox
  if (!checkBox.checked) {
    displayError(checkBox, 'Please accept the terms.');
  } else {
    clearError(checkBox);
  }

  // Call updateSubmitButton after validating fields
  updateSubmitButton();
}

function displayError(element, message) {
  // Display error message for the specified element
  var nextSibling = element.nextElementSibling;
  if (nextSibling) {
    var errorSpan = nextSibling.querySelector('.errorPass');
    if (errorSpan) {
      errorSpan.textContent = message;
    }
  }
}

function clearError(element) {
  // Clear error message for the specified element
  var nextSibling = element.nextElementSibling;
  if (nextSibling) {
    var errorSpan = nextSibling.querySelector('.errorPass');
    if (errorSpan) {
      errorSpan.textContent = '';
    }
  }
}

var setPassword = document.querySelector('.setPassword');
var confirmPassword = document.querySelector('.confirmPassword');
var newElement = document.createElement('span');
var buttonFiled = document.querySelector('.resetform .button');
newElement.classList.add("errorPass1");
setPassword?.nextElementSibling.after(newElement);
function updateSetSubmitButton() {
  var tgtpasswordField = setPassword?.value.trim();
   console.log(tgtpasswordField,"tgtpasswordFieldtgtpasswordField")
  var tgtconfirmPassword = confirmPassword?.value.trim();
  if (tgtpasswordField && tgtconfirmPassword) {
    let passwordRegex1 = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%&])[A-Za-z\d@#$%&]{8,15}$/;
    if (passwordRegex1.test(tgtpasswordField)) {
      newElement.textContent = 'Valid password';
      newElement.style.color = 'green';
      buttonFiled.setAttribute('type', 'submit');
    } else {
      newElement.textContent = 'Enter a valid password: minimum 8 characters, 1 uppercase, 1 lowercase, 1 number, 1 special character [ @ # $ % & * ].';
      newElement.style.color = 'red';
      buttonFiled.setAttribute('type', 'button');
    }
  }
}
  if(setPassword)
  {
    setPassword?.addEventListener('input', updateSetSubmitButton);
  }
if(confirmPassword)
{
  confirmPassword?.addEventListener('input', updateSetSubmitButton);
}


// this  is  for blog  article  font-size

 const article_fonts = document.querySelectorAll('.article__wrapper .v-stack .v-stack .prose p')

   article_fonts.forEach(function(article_font){
     article_font.style.fontSize = "16px"
   })

